export interface CountryInformation {
  dial_code: string | string[];
  code: string;
  name: string;
  isDisabled?: boolean;
}

export const countries = {
  US: {
    dial_code: "1",
    code: "US",
    name: "United States",
  },
  FR: {
    dial_code: "33",
    code: "FR",
    name: "France",
  },
  GB: {
    dial_code: "44",
    code: "GB",
    name: "United Kingdom",
  },
  ES: {
    dial_code: "34",
    code: "ES",
    name: "Spain",
  },
  NG: {
    dial_code: "234",
    code: "NG",
    name: "Nigeria",
  },
  NO: {
    dial_code: "47",
    code: "NO",
    name: "Norway",
  },
  CA: {
    dial_code: "1",
    code: "CA",
    name: "Canada",
  },
  IT: {
    dial_code: "39",
    code: "IT",
    name: "Italy",
  },
  KE: {
    dial_code: "254",
    code: "KE",
    name: "Kenya",
  },
  TR: {
    dial_code: "90",
    code: "TR",
    name: "Turkey",
  },
  BD: {
    dial_code: "880",
    code: "BD",
    name: "Bangladesh",
    isDisabled: true,
  },
  MT: {
    dial_code: "356",
    code: "MT",
    name: "Malta",
  },
  DE: {
    dial_code: "49",
    code: "DE",
    name: "Germany",
  },
  IE: {
    dial_code: "353",
    code: "IE",
    name: "Ireland",
  },
  MX: {
    dial_code: "52",
    code: "MX",
    name: "Mexico",
  },
  AE: {
    dial_code: "971",
    code: "AE",
    name: "United Arab Emirates",
  },
  BR: {
    dial_code: "55",
    code: "BR",
    name: "Brazil",
  },
  ZA: {
    dial_code: "27",
    code: "ZA",
    name: "South Africa",
  },
  SG: {
    dial_code: "65",
    code: "SG",
    name: "Singapore",
  },
  ID: {
    dial_code: "62",
    code: "ID",
    name: "Indonesia",
  },
  NL: {
    dial_code: "31",
    code: "NL",
    name: "Netherlands",
  },
  GR: {
    dial_code: "30",
    code: "GR",
    name: "Greece",
  },
  PK: {
    dial_code: "92",
    code: "PK",
    name: "Pakistan",
    isDisabled: true,
  },
  KR: {
    dial_code: "82",
    code: "KR",
    name: "South Korea",
  },
  AR: {
    dial_code: "54",
    code: "AR",
    name: "Argentina",
  },
  LB: {
    dial_code: "961",
    code: "LB",
    name: "Lebanon",
  },
  CD: {
    dial_code: "243",
    code: "CD",
    name: "Congo (Democratic Republic)",
  },
  JP: {
    dial_code: "81",
    code: "JP",
    name: "Japan",
  },
  AU: {
    dial_code: "61",
    code: "AU",
    name: "Australia",
  },
  AT: {
    dial_code: "43",
    code: "AT",
    name: "Austria",
  },
  CL: {
    dial_code: "56",
    code: "CL",
    name: "Chile",
  },
  IN: {
    dial_code: "91",
    code: "IN",
    name: "India",
  },
  CH: {
    dial_code: "41",
    code: "CH",
    name: "Switzerland",
  },
  BE: {
    dial_code: "32",
    code: "BE",
    name: "Belgium",
  },
  MA: {
    dial_code: "212",
    code: "MA",
    name: "Morocco",
  },
  RO: {
    dial_code: "40",
    code: "RO",
    name: "Romania",
  },
  FI: {
    dial_code: "358",
    code: "FI",
    name: "Finland",
  },
  MY: {
    dial_code: "60",
    code: "MY",
    name: "Malaysia",
  },
  PT: {
    dial_code: "351",
    code: "PT",
    name: "Portugal",
  },
  TN: {
    dial_code: "216",
    code: "TN",
    name: "Tunisia",
  },
  BG: {
    dial_code: "359",
    code: "BG",
    name: "Bulgaria",
  },
  RS: {
    dial_code: "381",
    code: "RS",
    name: "Serbia",
  },
  CO: {
    dial_code: "57",
    code: "CO",
    name: "Colombia",
  },
  TW: {
    dial_code: "886",
    code: "TW",
    name: "Taiwan",
  },
  EE: {
    dial_code: "372",
    code: "EE",
    name: "Estonia",
  },
  IL: {
    dial_code: "972",
    code: "IL",
    name: "Israel",
    isDisabled: true,
  },
  CR: {
    dial_code: "506",
    code: "CR",
    name: "Costa Rica",
  },
  SE: {
    dial_code: "46",
    code: "SE",
    name: "Sweden",
  },
  AD: {
    dial_code: "376",
    code: "AD",
    name: "Andorra",
  },
  PL: {
    dial_code: "48",
    code: "PL",
    name: "Poland",
  },
  AF: {
    dial_code: "93",
    code: "AF",
    name: "Afghanistan",
  },
  AX: {
    dial_code: "358",
    code: "AX",
    name: "Åland Islands",
  },
  AL: {
    dial_code: "355",
    code: "AL",
    name: "Albania",
  },
  DZ: {
    dial_code: "213",
    code: "DZ",
    name: "Algeria",
  },
  AS: {
    dial_code: "1684",
    code: "AS",
    name: "American Samoa",
  },
  AO: {
    dial_code: "244",
    code: "AO",
    name: "Angola",
  },
  AI: {
    dial_code: "1264",
    code: "AI",
    name: "Anguilla",
  },
  AQ: {
    dial_code: "672",
    code: "AQ",
    name: "Antarctica",
  },
  AG: {
    dial_code: "1268",
    code: "AG",
    name: "Antigua and Barbuda",
  },
  AM: {
    dial_code: "374",
    code: "AM",
    name: "Armenia",
  },
  AW: {
    dial_code: "297",
    code: "AW",
    name: "Aruba",
  },
  AZ: {
    dial_code: "994",
    code: "AZ",
    name: "Azerbaijan",
  },
  BS: {
    dial_code: "1242",
    code: "BS",
    name: "Bahamas",
  },
  BH: {
    dial_code: "973",
    code: "BH",
    name: "Bahrain",
  },
  BB: {
    dial_code: "1246",
    code: "BB",
    name: "Barbados",
  },
  BY: {
    dial_code: "375",
    code: "BY",
    name: "Belarus",
  },
  BZ: {
    dial_code: "501",
    code: "BZ",
    name: "Belize",
  },
  BJ: {
    dial_code: "229",
    code: "BJ",
    name: "Benin",
  },
  BM: {
    dial_code: "1441",
    code: "BM",
    name: "Bermuda",
  },
  BT: {
    dial_code: "975",
    code: "BT",
    name: "Bhutan",
  },
  BO: {
    dial_code: "591",
    code: "BO",
    name: "Bolivia",
  },
  BA: {
    dial_code: "387",
    code: "BA",
    name: "Bosnia and Herzegovina",
  },
  BW: {
    dial_code: "267",
    code: "BW",
    name: "Botswana",
  },
  IO: {
    dial_code: "246",
    code: "IO",
    name: "British Indian Ocean Territory",
  },
  BN: {
    dial_code: "673",
    code: "BN",
    name: "Brunei",
  },
  BF: {
    dial_code: "226",
    code: "BF",
    name: "Burkina Faso",
  },
  BI: {
    dial_code: "257",
    code: "BI",
    name: "Burundi",
  },
  KH: {
    dial_code: "855",
    code: "KH",
    name: "Cambodia",
  },
  CM: {
    dial_code: "237",
    code: "CM",
    name: "Cameroon",
  },
  CV: {
    dial_code: "238",
    code: "CV",
    name: "Cape Verde",
  },
  KY: {
    dial_code: "345",
    code: "KY",
    name: "Cayman Islands",
  },
  CF: {
    dial_code: "236",
    code: "CF",
    name: "Central African Republic",
  },
  TD: {
    dial_code: "235",
    code: "TD",
    name: "Chad",
  },
  CN: {
    dial_code: "86",
    code: "CN",
    name: "China",
  },
  CX: {
    dial_code: "61",
    code: "CX",
    name: "Christmas Island",
  },
  CC: {
    dial_code: "61",
    code: "CC",
    name: "Cocos (Keeling) Islands",
  },
  KM: {
    dial_code: "269",
    code: "KM",
    name: "Comoros",
  },
  CG: {
    dial_code: "242",
    code: "CG",
    name: "Congo",
  },
  CK: {
    dial_code: "682",
    code: "CK",
    name: "Cook Islands",
  },
  CI: {
    dial_code: "225",
    code: "CI",
    name: "Ivory Coast",
  },
  HR: {
    dial_code: "385",
    code: "HR",
    name: "Croatia",
  },
  CU: {
    dial_code: "53",
    code: "CU",
    name: "Cuba",
  },
  CY: {
    dial_code: "357",
    code: "CY",
    name: "Cyprus",
  },
  CZ: {
    dial_code: "420",
    code: "CZ",
    name: "Czech Republic",
  },
  DK: {
    dial_code: "45",
    code: "DK",
    name: "Denmark",
  },
  DJ: {
    dial_code: "253",
    code: "DJ",
    name: "Djibouti",
  },
  DM: {
    dial_code: "1767",
    code: "DM",
    name: "Dominica",
  },
  DO: {
    dial_code: "1849",
    code: "DO",
    name: "Dominican Republic",
  },
  EC: {
    dial_code: "593",
    code: "EC",
    name: "Ecuador",
  },
  EG: {
    dial_code: "20",
    code: "EG",
    name: "Egypt",
  },
  SV: {
    dial_code: "503",
    code: "SV",
    name: "El Salvador",
  },
  GQ: {
    dial_code: "240",
    code: "GQ",
    name: "Equatorial Guinea",
  },
  ER: {
    dial_code: "291",
    code: "ER",
    name: "Eritrea",
  },
  ET: {
    dial_code: "251",
    code: "ET",
    name: "Ethiopia",
  },
  FK: {
    dial_code: "500",
    code: "FK",
    name: "Falkland Islands",
  },
  FO: {
    dial_code: "298",
    code: "FO",
    name: "Faroe Islands",
  },
  FJ: {
    dial_code: "679",
    code: "FJ",
    name: "Fiji",
  },
  GF: {
    dial_code: "594",
    code: "GF",
    name: "French Guiana",
  },
  PF: {
    dial_code: "689",
    code: "PF",
    name: "French Polynesia",
  },
  GA: {
    dial_code: "241",
    code: "GA",
    name: "Gabon",
  },
  GM: {
    dial_code: "220",
    code: "GM",
    name: "Gambia",
  },
  GE: {
    dial_code: "995",
    code: "GE",
    name: "Georgia",
  },
  GH: {
    dial_code: "233",
    code: "GH",
    name: "Ghana",
  },
  GI: {
    dial_code: "350",
    code: "GI",
    name: "Gibraltar",
  },
  GL: {
    dial_code: "299",
    code: "GL",
    name: "Greenland",
  },
  GD: {
    dial_code: "1473",
    code: "GD",
    name: "Grenada",
  },
  GP: {
    dial_code: "590",
    code: "GP",
    name: "Guadeloupe",
  },
  GU: {
    dial_code: "1671",
    code: "GU",
    name: "Guam",
  },
  GT: {
    dial_code: "502",
    code: "GT",
    name: "Guatemala",
  },
  GG: {
    dial_code: "44",
    code: "GG",
    name: "Guernsey",
  },
  GN: {
    dial_code: "224",
    code: "GN",
    name: "Guinea",
  },
  GW: {
    dial_code: "245",
    code: "GW",
    name: "Guinea-Bissau",
  },
  GY: {
    dial_code: "595",
    code: "GY",
    name: "Guyana",
  },
  HT: {
    dial_code: "509",
    code: "HT",
    name: "Haiti",
  },
  VA: {
    dial_code: "379",
    code: "VA",
    name: "Vatican City",
  },
  HN: {
    dial_code: "504",
    code: "HN",
    name: "Honduras",
  },
  HK: {
    dial_code: "852",
    code: "HK",
    name: "Hong Kong",
  },
  HU: {
    dial_code: "36",
    code: "HU",
    name: "Hungary",
  },
  IS: {
    dial_code: "354",
    code: "IS",
    name: "Iceland",
  },
  IR: {
    dial_code: "98",
    code: "IR",
    name: "Iran",
    isDisabled: true,
  },
  IQ: {
    dial_code: "964",
    code: "IQ",
    name: "Iraq",
  },
  IM: {
    dial_code: "44",
    code: "IM",
    name: "Isle of Man",
  },
  JM: {
    dial_code: "1876",
    code: "JM",
    name: "Jamaica",
  },
  JE: {
    dial_code: "44",
    code: "JE",
    name: "Jersey",
  },
  JO: {
    dial_code: "962",
    code: "JO",
    name: "Jordan",
  },
  KZ: {
    dial_code: "77",
    code: "KZ",
    name: "Kazakhstan",
  },
  KI: {
    dial_code: "686",
    code: "KI",
    name: "Kiribati",
  },
  KP: {
    dial_code: "850",
    code: "KP",
    name: "North Korea",
  },
  KW: {
    dial_code: "965",
    code: "KW",
    name: "Kuwait",
  },
  KG: {
    dial_code: "996",
    code: "KG",
    name: "Kyrgyzstan",
  },
  LA: {
    dial_code: "856",
    code: "LA",
    name: "Laos",
  },
  LV: {
    dial_code: "371",
    code: "LV",
    name: "Latvia",
  },
  LS: {
    dial_code: "266",
    code: "LS",
    name: "Lesotho",
  },
  LR: {
    dial_code: "231",
    code: "LR",
    name: "Liberia",
  },
  LY: {
    dial_code: "218",
    code: "LY",
    name: "Libya",
  },
  LI: {
    dial_code: "423",
    code: "LI",
    name: "Liechtenstein",
  },
  LT: {
    dial_code: "370",
    code: "LT",
    name: "Lithuania",
  },
  LU: {
    dial_code: "352",
    code: "LU",
    name: "Luxembourg",
  },
  MO: {
    dial_code: "853",
    code: "MO",
    name: "Macau",
  },
  MK: {
    dial_code: "389",
    code: "MK",
    name: "North Macedonia",
  },
  MG: {
    dial_code: "261",
    code: "MG",
    name: "Madagascar",
  },
  MW: {
    dial_code: "265",
    code: "MW",
    name: "Malawi",
  },
  MV: {
    dial_code: "960",
    code: "MV",
    name: "Maldives",
  },
  ML: {
    dial_code: "223",
    code: "ML",
    name: "Mali",
  },
  MH: {
    dial_code: "692",
    code: "MH",
    name: "Marshall Islands",
  },
  MQ: {
    dial_code: "596",
    code: "MQ",
    name: "Martinique",
  },
  MR: {
    dial_code: "222",
    code: "MR",
    name: "Mauritania",
  },
  MU: {
    dial_code: "230",
    code: "MU",
    name: "Mauritius",
  },
  YT: {
    dial_code: "262",
    code: "YT",
    name: "Mayotte",
  },
  FM: {
    dial_code: "691",
    code: "FM",
    name: "Micronesia",
  },
  MD: {
    dial_code: "373",
    code: "MD",
    name: "Moldova",
  },
  MC: {
    dial_code: "377",
    code: "MC",
    name: "Monaco",
  },
  MN: {
    dial_code: "976",
    code: "MN",
    name: "Mongolia",
  },
  ME: {
    dial_code: "382",
    code: "ME",
    name: "Montenegro",
  },
  MS: {
    dial_code: "1664",
    code: "MS",
    name: "Montserrat",
  },
  MZ: {
    dial_code: "258",
    code: "MZ",
    name: "Mozambique",
  },
  MM: {
    dial_code: "95",
    code: "MM",
    name: "Myanmar",
  },
  NA: {
    dial_code: "264",
    code: "NA",
    name: "Namibia",
  },
  NR: {
    dial_code: "674",
    code: "NR",
    name: "Nauru",
  },
  NP: {
    dial_code: "977",
    code: "NP",
    name: "Nepal",
  },
  AN: {
    dial_code: "599",
    code: "AN",
    name: "Netherlands Antilles",
  },
  NC: {
    dial_code: "687",
    code: "NC",
    name: "New Caledonia",
  },
  NZ: {
    dial_code: "64",
    code: "NZ",
    name: "New Zealand",
  },
  NI: {
    dial_code: "505",
    code: "NI",
    name: "Nicaragua",
  },
  NE: {
    dial_code: "227",
    code: "NE",
    name: "Niger",
  },
  NU: {
    dial_code: "683",
    code: "NU",
    name: "Niue",
  },
  NF: {
    dial_code: "672",
    code: "NF",
    name: "Norfolk Island",
  },
  MP: {
    dial_code: "1670",
    code: "MP",
    name: "Northern Mariana Islands",
  },
  OM: {
    dial_code: "968",
    code: "OM",
    name: "Oman",
    isDisabled: true,
  },
  PW: {
    dial_code: "680",
    code: "PW",
    name: "Palau",
  },
  PS: {
    dial_code: "970",
    code: "PS",
    name: "Palestine",
    isDisabled: true,
  },
  PA: {
    dial_code: "507",
    code: "PA",
    name: "Panama",
  },
  PG: {
    dial_code: "675",
    code: "PG",
    name: "Papua New Guinea",
  },
  PY: {
    dial_code: "595",
    code: "PY",
    name: "Paraguay",
  },
  PE: {
    dial_code: "51",
    code: "PE",
    name: "Peru",
  },
  PH: {
    dial_code: "63",
    code: "PH",
    name: "Philippines",
  },
  PN: {
    dial_code: "872",
    code: "PN",
    name: "Pitcairn Islands",
  },
  PR: {
    dial_code: "1939",
    code: "PR",
    name: "Puerto Rico",
  },
  QA: {
    dial_code: "974",
    code: "QA",
    name: "Qatar",
  },
  RU: {
    dial_code: "7",
    code: "RU",
    name: "Russia",
  },
  RW: {
    dial_code: "250",
    code: "RW",
    name: "Rwanda",
  },
  RE: {
    dial_code: "262",
    code: "RE",
    name: "Réunion",
  },
  BL: {
    dial_code: "590",
    code: "BL",
    name: "Saint Barthélemy",
  },
  SH: {
    dial_code: "290",
    code: "SH",
    name: "Saint Helena",
  },
  KN: {
    dial_code: "1869",
    code: "KN",
    name: "Saint Kitts and Nevis",
  },
  LC: {
    dial_code: "1758",
    code: "LC",
    name: "Saint Lucia",
  },
  MF: {
    dial_code: "590",
    code: "MF",
    name: "Saint Martin",
  },
  PM: {
    dial_code: "508",
    code: "PM",
    name: "Saint Pierre and Miquelon",
  },
  VC: {
    dial_code: "1784",
    code: "VC",
    name: "Saint Vincent and the Grenadines",
  },
  WS: {
    dial_code: "685",
    code: "WS",
    name: "Samoa",
  },
  SM: {
    dial_code: "378",
    code: "SM",
    name: "San Marino",
  },
  ST: {
    dial_code: "239",
    code: "ST",
    name: "São Tomé and Príncipe",
  },
  SA: {
    dial_code: "966",
    code: "SA",
    name: "Saudi Arabia",
  },
  SN: {
    dial_code: "221",
    code: "SN",
    name: "Senegal",
  },
  SC: {
    dial_code: "248",
    code: "SC",
    name: "Seychelles",
  },
  SL: {
    dial_code: "232",
    code: "SL",
    name: "Sierra Leone",
  },
  SK: {
    dial_code: "421",
    code: "SK",
    name: "Slovakia",
  },
  SI: {
    dial_code: "386",
    code: "SI",
    name: "Slovenia",
  },
  SB: {
    dial_code: "677",
    code: "SB",
    name: "Solomon Islands",
  },
  SO: {
    dial_code: "252",
    code: "SO",
    name: "Somalia",
  },
  SS: {
    dial_code: "211",
    code: "SS",
    name: "South Sudan",
  },
  GS: {
    dial_code: "500",
    code: "GS",
    name: "South Georgia and the South Sandwich Islands",
  },
  LK: {
    dial_code: "94",
    code: "LK",
    name: "Sri Lanka",
    isDisabled: true,
  },
  SD: {
    dial_code: "249",
    code: "SD",
    name: "Sudan",
  },
  SR: {
    dial_code: "597",
    code: "SR",
    name: "Suriname",
  },
  SJ: {
    dial_code: "47",
    code: "SJ",
    name: "Svalbard and Jan Mayen",
  },
  SZ: {
    dial_code: "268",
    code: "SZ",
    name: "Eswatini",
  },
  SY: {
    dial_code: "963",
    code: "SY",
    name: "Syria",
  },
  TJ: {
    dial_code: "992",
    code: "TJ",
    name: "Tajikistan",
    isDisabled: true,
  },
  TZ: {
    dial_code: "255",
    code: "TZ",
    name: "Tanzania",
  },
  TH: {
    dial_code: "66",
    code: "TH",
    name: "Thailand",
  },
  TL: {
    dial_code: "670",
    code: "TL",
    name: "Timor-Leste",
  },
  TG: {
    dial_code: "228",
    code: "TG",
    name: "Togo",
  },
  TK: {
    dial_code: "690",
    code: "TK",
    name: "Tokelau",
  },
  TO: {
    dial_code: "676",
    code: "TO",
    name: "Tonga",
  },
  TT: {
    dial_code: "1868",
    code: "TT",
    name: "Trinidad and Tobago",
  },
  TM: {
    dial_code: "993",
    code: "TM",
    name: "Turkmenistan",
  },
  TC: {
    dial_code: "1649",
    code: "TC",
    name: "Turks and Caicos Islands",
  },
  TV: {
    dial_code: "688",
    code: "TV",
    name: "Tuvalu",
  },
  UG: {
    dial_code: "256",
    code: "UG",
    name: "Uganda",
  },
  UA: {
    dial_code: "380",
    code: "UA",
    name: "Ukraine",
  },
  UY: {
    dial_code: "598",
    code: "UY",
    name: "Uruguay",
  },
  UZ: {
    dial_code: "998",
    code: "UZ",
    name: "Uzbekistan",
  },
  VU: {
    dial_code: "678",
    code: "VU",
    name: "Vanuatu",
  },
  VE: {
    dial_code: "58",
    code: "VE",
    name: "Venezuela",
  },
  VN: {
    dial_code: "84",
    code: "VN",
    name: "Vietnam",
  },
  VG: {
    dial_code: "1284",
    code: "VG",
    name: "British Virgin Islands",
  },
  VI: {
    dial_code: "1340",
    code: "VI",
    name: "United States Virgin Islands",
  },
  WF: {
    dial_code: "681",
    code: "WF",
    name: "Wallis and Futuna",
  },
  YE: {
    dial_code: "967",
    code: "YE",
    name: "Yemen",
  },
  ZM: {
    dial_code: "260",
    code: "ZM",
    name: "Zambia",
  },
  ZW: {
    dial_code: "263",
    code: "ZW",
    name: "Zimbabwe",
  },
} as const satisfies Record<string, CountryInformation>;

export const parsePhoneNumber = (phoneNumber: string) => {
  phoneNumber = phoneNumber.startsWith("+")
    ? phoneNumber.slice(1)
    : phoneNumber;

  for (const countryCode in countries) {
    const { dial_code } = countries[countryCode as CountryCode];
    if (phoneNumber.startsWith(dial_code)) {
      return {
        success: true,
        countryCode,
        number: phoneNumber.slice(dial_code.length),
      };
    }
  }
  return {
    success: false,
    message: `No matching country code found for phone number ${phoneNumber}`,
  };
};

export type CountryCode = keyof typeof countries;
export type CountryPhoneCode = (typeof countries)[CountryCode]["dial_code"];

export const languages = [
  // { code: "aa", name: "Afar" },
  // { code: "ab", name: "Abkhazian" },
  // { code: "ae", name: "Avestan" },
  // { code: "af", name: "Afrikaans" },
  // { code: "ak", name: "Akan" },
  // { code: "am", name: "Amharic" },
  // { code: "an", name: "Aragonese" },
  { code: "ar", name: "Arabic" },
  // { code: "as", name: "Assamese" },
  // { code: "av", name: "Avaric" },
  // { code: "ay", name: "Aymara" },
  // { code: "az", name: "Azerbaijani" },
  // { code: "ba", name: "Bashkir" },
  // { code: "be", name: "Belarusian" },
  // { code: "bg", name: "Bulgarian" },
  // { code: "bh", name: "Bihari languages" },
  // { code: "bi", name: "Bislama" },
  // { code: "bm", name: "Bambara" },
  // { code: "bn", name: "Bengali" },
  // { code: "bo", name: "Tibetan" },
  // { code: "br", name: "Breton" },
  { code: "bs", name: "Bosnian" },
  // { code: "ca", name: "Catalan; Valencian" },
  // { code: "ce", name: "Chechen" },
  // { code: "ch", name: "Chamorro" },
  // { code: "co", name: "Corsican" },
  // { code: "cr", name: "Cree" },
  // { code: "cs", name: "Czech" },
  // { code: "cv", name: "Chuvash" },
  // { code: "cy", name: "Welsh" },
  // { code: "da", name: "Danish" },
  // { code: "de", name: "German" },
  // { code: "dv", name: "Divehi; Dhivehi; Maldivian" },
  // { code: "dz", name: "Dzongkha" },
  // { code: "ee", name: "Ewe" },
  // { code: "el", name: "Greek, Modern (1453)" },
  { code: "en", name: "English" },
  // { code: "eo", name: "Esperanto" },
  { code: "es", name: "Spanish; Castilian" },
  // { code: "et", name: "Estonian" },
  // { code: "eu", name: "Basque" },
  // { code: "fa", name: "Persian" },
  // { code: "ff", name: "Fulah" },
  // { code: "fi", name: "Finnish" },
  // { code: "fj", name: "Fijian" },
  // { code: "fo", name: "Faroese" },
  { code: "fr", name: "French" },
  // { code: "fy", name: "Western Frisian" },
  // { code: "ga", name: "Irish" },
  // { code: "gd", name: "Gaelic; Scomttish Gaelic" },
  // { code: "gl", name: "Galician" },
  // { code: "gn", name: "Guarani" },
  // { code: "gu", name: "Gujarati" },
  // { code: "gv", name: "Manx" },
  // { code: "ha", name: "Hausa" },
  // { code: "he", name: "Hebrew" },
  // { code: "hi", name: "Hindi" },
  // { code: "ho", name: "Hiri Motu" },
  // { code: "hr", name: "Croatian" },
  // { code: "ht", name: "Haitian; Haitian Creole" },
  // { code: "hu", name: "Hungarian" },
  // { code: "hy", name: "Armenian" },
  // { code: "hz", name: "Herero" },
  // { code: "id", name: "Indonesian" },
  // { code: "ie", name: "Interlingue; Occidental" },
  // { code: "ig", name: "Igbo" },
  // { code: "ii", name: "Sichuan Yi; Nuosu" },
  // { code: "ik", name: "Inupiaq" },
  // { code: "io", name: "Ido" },
  // { code: "is", name: "Icelandic" },
  { code: "it", name: "Italian" },
  // { code: "iu", name: "Inuktitut" },
  // { code: "ja", name: "Japanese" },
  // { code: "jv", name: "Javanese" },
  // { code: "ka", name: "Georgian" },
  // { code: "kg", name: "Kongo" },
  // { code: "ki", name: "Kikuyu; Gikuyu" },
  // { code: "kj", name: "Kuanyama; Kwanyama" },
  // { code: "kk", name: "Kazakh" },
  // { code: "kl", name: "Kalaallisut; Greenlandic" },
  // { code: "km", name: "Central Khmer" },
  // { code: "kn", name: "Kannada" },
  // { code: "ko", name: "Korean" },
  // { code: "kr", name: "Kanuri" },
  // { code: "ks", name: "Kashmiri" },
  // { code: "ku", name: "Kurdish" },
  // { code: "kv", name: "Komi" },
  // { code: "kw", name: "Cornish" },
  // { code: "ky", name: "Kirghiz; Kyrgyz" },
  // { code: "la", name: "Latin" },
  // { code: "lb", name: "Luxembourgish; Letzeburgesch" },
  // { code: "lg", name: "Ganda" },
  // { code: "li", name: "Limburgan; Limburger; Limburgish" },
  // { code: "ln", name: "Lingala" },
  // { code: "lo", name: "Lao" },
  // { code: "lt", name: "Lithuanian" },
  // { code: "lu", name: "LubaKatanga" },
  // { code: "lv", name: "Latvian" },
  // { code: "mg", name: "Malagasy" },
  // { code: "mh", name: "Marshallese" },
  // { code: "mi", name: "Maori" },
  // { code: "mk", name: "Macedonian" },
  // { code: "ml", name: "Malayalam" },
  // { code: "mn", name: "Mongolian" },
  // { code: "mr", name: "Marathi" },
  // { code: "ms", name: "Malay" },
  // { code: "mt", name: "Maltese" },
  // { code: "my", name: "Burmese" },
  // { code: "na", name: "Nauru" },
  // {
  //   code: "nb",
  //   name: "Bokmål, Norwegian; Norwegian Bokmål",
  // },
  // { code: "nd", name: "Ndebele, North; North Ndebele" },
  // { code: "ne", name: "Nepali" },
  // { code: "ng", name: "Ndonga" },
  // { code: "nl", name: "Dutch; Flemish" },
  // { code: "nn", name: "Norwegian Nynorsk; Nynorsk, Norwegian" },
  { code: "no", name: "Norwegian" },
  // { code: "nr", name: "Ndebele, South; South Ndebele" },
  // { code: "nv", name: "Navajo; Navaho" },
  // { code: "ny", name: "Chichewa; Chewa; Nyanja" },
  // { code: "oc", name: "Occitan (post 1500)" },
  // { code: "oj", name: "Ojibwa" },
  // { code: "om", name: "Oromo" },
  // { code: "or", name: "Oriya" },
  // { code: "os", name: "Ossetian; Ossetic" },
  // { code: "pa", name: "Panjabi; Punjabi" },
  // { code: "pi", name: "Pali" },
  // { code: "pl", name: "Polish" },
  // { code: "ps", name: "Pushto; Pashto" },
  { code: "pt", name: "Portuguese" },
  // { code: "qu", name: "Quechua" },
  // { code: "rm", name: "Romansh" },
  // { code: "rn", name: "Rundi" },
  // { code: "ro", name: "Romanian; Moldavian; Moldovan" },
  // { code: "ru", name: "Russian" },
  // { code: "rw", name: "Kinyarwanda" },
  // { code: "sa", name: "Sanskrit" },
  // { code: "sc", name: "Sardinian" },
  // { code: "sd", name: "Sindhi" },
  // { code: "se", name: "Northern Sami" },
  // { code: "sg", name: "Sango" },
  // { code: "si", name: "Sinhala; Sinhalese" },
  // { code: "sk", name: "Slovak" },
  // { code: "sl", name: "Slovenian" },
  // { code: "sm", name: "Samoan" },
  // { code: "sn", name: "Shona" },
  // { code: "so", name: "Somali" },
  // { code: "sq", name: "Albanian" },
  // { code: "sr", name: "Serbian" },
  // { code: "ss", name: "Swati" },
  // { code: "st", name: "Sotho, Southern" },
  // { code: "su", name: "Sundanese" },
  // { code: "sv", name: "Swedish" },
  // { code: "sw", name: "Swahili" },
  // { code: "ta", name: "Tamil" },
  // { code: "te", name: "Telugu" },
  // { code: "tg", name: "Tajik" },
  // { code: "th", name: "Thai" },
  // { code: "ti", name: "Tigrinya" },
  // { code: "tk", name: "Turkmen" },
  // { code: "tl", name: "Tagalog" },
  // { code: "tn", name: "Tswana" },
  // { code: "to", name: "Tonga (Tonga Islands)" },
  // { code: "tr", name: "Turkish" },
  // { code: "ts", name: "Tsonga" },
  // { code: "tt", name: "Tatar" },
  // { code: "tw", name: "Twi" },
  // { code: "ty", name: "Tahitian" },
  // { code: "ug", name: "Uighur; Uyghur" },
  // { code: "uk", name: "Ukrainian" },
  // { code: "ur", name: "Urdu" },
  // { code: "uz", name: "Uzbek" },
  // { code: "ve", name: "Venda" },
  // { code: "vi", name: "Vietnamese" },
  // { code: "vo", name: "Volapük" },
  // { code: "wa", name: "Walloon" },
  // { code: "wo", name: "Wolof" },
  // { code: "xh", name: "Xhosa" },
  // { code: "yi", name: "Yiddish" },
  // { code: "yo", name: "Yoruba" },
  // { code: "za", name: "Zhuang; Chuang" },
  // { code: "zh", name: "Chinese" },
  // { code: "zu", name: "Zulu" },
];

export type Language = (typeof languages)[number];

export interface InternationalPhoneNumber {
  countryCode: CountryCode;
  number: string;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- static-only namespace grouping the country and language lookup helpers
export abstract class CountryData {
  static countries = countries;
  static languages = languages;

  static getCountriesWithNames() {
    const nameFormat = new Intl.DisplayNames(window.navigator.language, {
      type: "region",
    });
    return Object.entries(countries).map(([code]) => ({
      code,
      name: nameFormat.of(code),
    }));
  }

  static getCountryName(code: string) {
    const nameFormat = new Intl.DisplayNames(window.navigator.language, {
      type: "region",
    });
    return nameFormat.of(code);
  }

  static getLanguageName(code: string) {
    const nameFormat = new Intl.DisplayNames(window.navigator.language, {
      type: "language",
    });
    return nameFormat.of(code);
  }
}

export const defaultInternationalPhoneNumber: InternationalPhoneNumber = {
  countryCode: "US",
  number: "",
};

export function getFullPhoneNumber(phoneNumber: InternationalPhoneNumber) {
  return `+${countries[phoneNumber.countryCode].dial_code}${phoneNumber.number}`;
}
